import React from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../../common/head-container';

const AttemptsExhausted = ({
  setScreenNumber,
  telegramLink,
  checkPhoneNumber
}) => {
  return (
    <div
      className={styles.container}
      style={{ backgroundImage: 'url("/images/26ua-lm-lfc-auth/bg.png")' }}
    >
      <HeadContainer
        setScreenNumber={setScreenNumber}
        customTelegramLink={telegramLink}
        telegramOnly
      />
      <div className={styles.content}>
        <p className={styles.title}>Спроби вичерпані:(</p>
        <p className={styles.description}>
          Спробуй перевірити вказаний номер телефону та зареєструватися знову!
        </p>
        <button onClick={checkPhoneNumber} className={styles.nextButton}>
          <img
            className={styles.buttonGlow}
            src="/images/26ua-lm-lfc-auth/button-glow.svg"
            alt=""
          />
          <span>Перевірити номер</span>
        </button>
      </div>
    </div>
  );
};

export default AttemptsExhausted;
